import { render, staticRenderFns } from "./Investimento.vue?vue&type=template&id=86aef1be&scoped=true"
import script from "./Investimento.vue?vue&type=script&lang=js"
export * from "./Investimento.vue?vue&type=script&lang=js"
import style0 from "./Investimento.vue?vue&type=style&index=0&id=86aef1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86aef1be",
  null
  
)

export default component.exports